// extracted by mini-css-extract-plugin
export default {"sharerContainer":"Sharer_sharerContainer__fV02C","sharerName":"Sharer_sharerName__eCU+S"};